import React, { Component } from "react";
import { Form} from "semantic-ui-react";
import Select from "antd/es/select";
import "antd/es/select/style/index.css";
import './styles.scss';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import functionCommon from "../../core/common/function";

import _ from 'lodash'
class OmProjectForm extends Component {
    constructor() {
        super();
        this.state = {
            errInputMsg: {},
            projectId: '',
            employeeId: ''
        }

    }
    
    componentWillReceiveProps(nextProps) {
        this.setState({
            errInputMsg: nextProps.isError,
            projectId: parseInt(nextProps.omProjectData.projectId) || '',
            employeeId: parseInt(nextProps.omProjectData.employeeId) || ''
        });
    }

    onChangeProject = (value ) => {
        this.props.changeOmProject({_name: "projectId", _value: value});
    }

    onChangeEmployee = (value ) => {
        this.props.changeOmProject({_name: "employeeId", _value: value});
    }

    employeeProcess = (rawData) => {
        if (rawData && rawData.length > 0) {
            const employee = rawData.map((ele) => {
                return {
                    value: ele.id,
                    name: ele.employeeCode + " - " + ele.employeeName,
                }
            });
            return employee;
        } else return [];
    }
    
    render() {
        const { omProjectData, projectData, employeeData, t } = this.props;
        const _employeeData = this.employeeProcess(employeeData);
        const _projectData = _.map(projectData, (state, index) => ({
            key: "project-" + index + 1,
            text: state['projectCode'] + ' - ' + state['projectName'],
            value: state['id'],
        }))
        _projectData.unshift({
            key: "project-0",
            text: 'All',
            value: '',
        })        
        const { Option } = Select;

        return (
            <div className="employee-form om-project-form">
                <Form>
                    <Form.Group inline className="form-required">
                        <label>{t("labels.project")}</label>
                        <Select
                            name="projectId"
                            onChange={this.onChangeProject}
                            style={{ width: 200 }}
                            showSearch
                            filterOption={(input, option) =>
                                option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            value={this.state.projectId}
                        >
                            {_projectData.map((item, index)=> 
                                <Option value={item.value} key={item.key} label={item.text}>{item.text}</Option>
                            )}
                        </Select>
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg["projectId"])}</div>
                    <Form.Group inline className="form-required">
                        <label>{t("labels.employee")}</label>
                        <Select
                            name="employeeId"
                            onChange={this.onChangeEmployee}
                            style={{ width: 200 }}
                            showSearch
                            filterOption={functionCommon.filterEmployee}
                            value={this.state.employeeId}
                        >
                            <Option value={''}  label={'All'}>All</Option>
                            {_employeeData.map((item, index)=> 
                                <Option value={item.value} key={item.key} label={item.name}>{item.name}</Option>
                            )}
                        </Select>
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg["employeeId"])}</div>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(OmProjectForm);
